import * as types from './mutation-types'

export default {
  [types.ADD_MAIL](state, data) {
    state.mail = data
  },
  [types.ADD_EMAIL_ENUM](state, data) {
    state.emailEnum = data
  },
}
